import React from "react";
import { Button } from "primereact/button";

export const ExportButtonTemplate = (payoutExtractId:any,handleExport:any) => {           
    return (
        <div style={{ textAlign: "center" }}>
            <Button
                type="button"
                onClick={()=>handleExport(payoutExtractId)}
                icon="pi pi-upload"
                style={{ background: "transparent", border: "#CECECD 1px solid", color: "#3F5765" }}
            />
        </div>
    );
};